import React from 'react';
import PropTypes from 'prop-types';
import Badge from '@material-ui/core/Badge';
import AppBarActionIconButton from '@sprinx/react-mui-layout/AppBarActionIconButton';

function AppBarActionCartIconButton(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      handleClick = _ref.onClick,
      subjectCount = _ref.subjectCount;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Badge, {
    badgeContent: subjectCount,
    color: "secondary",
    invisible: !(subjectCount && subjectCount > 0),
    overlap: "circle"
  }, /*#__PURE__*/React.createElement(AppBarActionIconButton, {
    color: "inherit",
    iconColor: "inherit",
    icon: icon,
    label: label,
    onClick: handleClick
  })));
}

process.env.NODE_ENV !== "production" ? AppBarActionCartIconButton.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  subjectCount: PropTypes.number
} : void 0;
AppBarActionCartIconButton.defaultProps = {
  onClick: undefined,
  subjectCount: undefined
};
export default AppBarActionCartIconButton;